export const SET_USER_DATA = "SET_USER_DATA";
export const GAME_BAL_CHANGE = "GAME_BAL_CHANGE";
export const USER_LOGOUT = "USER_LOGOUT";
export const CHANGE_USER_BALANCE = "CHANGE_USER_BALANCE";
export const MAIN_TO_GAME = "MAIN_TO_GAME";
export const GAME_TO_MAIN = "GAME_TO_MAIN";
export const GAME_REF_AMT_CLAIM = "GAME_REF_AMT_CLAIM";
export const GAME_CATEGORY = "GAME_CATEGORY";
export const GAME_PROVIDER = "GAME_PROVIDER";
